import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React from 'react';
import { withIcon } from '../../../../components/withIcon/withIcon.es.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var SvgHandOutlined = function SvgHandOutlined(_a) {
  var _b = _a,
      size = _b.size,
      _b$title = _b.title,
      title = _b$title === void 0 ? "HandOutlined" : _b$title,
      props = __objRest(_b, ["size", "title"]);

  return (
    /* @__PURE__ */
    React.createElement("svg", __spreadValues({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      width: size,
      height: size,
      "data-icon-name": title,
      "aria-label": title,
      role: "presentation"
    }, props),
    /* @__PURE__ */
    React.createElement("g", {
      stroke: "currentColor",
      strokeLinecap: "square",
      strokeMiterlimit: 10,
      strokeWidth: 1.5,
      clipPath: "url(#hand-outlined_svg__hand-outlined_svg__clip0_2125_170574)"
    },
    /* @__PURE__ */
    React.createElement("path", {
      d: "M15.927 8.227l.514-.514c.273-.273.423-.646.417-1.038a1.523 1.523 0 00-.448-1.05 1.523 1.523 0 00-1.051-.449 1.433 1.433 0 00-1.038.417L9.424 10.49a.71.71 0 01-.303.18.736.736 0 01-.356.013.763.763 0 01-.545-.442L7.395 8.37a1.367 1.367 0 00-.492-.585 1.342 1.342 0 00-.724-.227v0a1.272 1.272 0 00-.89.34 1.266 1.266 0 00-.398.863l-.186 3.597a6.735 6.735 0 00.452 2.786 6.92 6.92 0 001.557 2.384l1.016 1.016a6.852 6.852 0 004.728 2.017 6.449 6.449 0 004.67-1.876l4.372-4.37c.204-.205.317-.486.312-.78a1.143 1.143 0 00-.336-.787 1.142 1.142 0 00-.788-.336 1.075 1.075 0 00-.778.312l-.258.257"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      d: "M12.841 11.313l4.114-4.115a1.433 1.433 0 011.038-.416c.392.006.77.167 1.05.448.282.281.443.66.449 1.05a1.43 1.43 0 01-.417 1.038l-4.114 4.115m3.086-3.086l.514-.514a1.433 1.433 0 011.038-.417c.391.006.77.167 1.05.448v0c.281.281.443.66.449 1.051.006.392-.144.765-.417 1.038l-3.6 3.6"
    })),
    /* @__PURE__ */
    React.createElement("defs", null,
    /* @__PURE__ */
    React.createElement("clipPath", {
      id: "hand-outlined_svg__hand-outlined_svg__clip0_2125_170574"
    },
    /* @__PURE__ */
    React.createElement("path", {
      fill: "currentColor",
      d: "M0 0h24v24H0z",
      transform: "translate(.5)"
    }))))
  );
};

var HandOutlined = withIcon(SvgHandOutlined);
export { HandOutlined as default };